import { InfluencerProfileAudience, InfluencerProfileAudienceProps } from '../shared';

type InfluencerTwitterProfileAudienceProps = InfluencerProfileAudienceProps;

export const InfluencerTwitterProfileAudience = (props: InfluencerTwitterProfileAudienceProps) => (
  <InfluencerProfileAudience {...props} />
);
